module.exports = __webpack_public_path__ + "img/regis_s.c6411cb1.png";